'use client';

import React from 'react';
import classNames from 'classnames';
import { FileSendIcon } from '../../Icons';

const BASE_CLASSES =
  'inline-flex h-[var(--button-master-S-S-height,40px)] py-[var(--button-master-S-S-v-padding,8px)] pl-[var(--button-master-S-S-h-padding,12px)] pr-[var(--button-master-S-S-h-text-padding,20px)] justify-center items-center gap-[var(--button-master-S-S-spacing,8px)] rounded-[var(--button-master-S-S-radius,6px)] bg-ds-bg-surface-soft-3 text-ds-text-s font-semibold text-ds-text-1 focus:outline-none focus:ring-2 focus:ring-ds-aqua-400 focus:ring-offset-2 hover:opacity-90 cursor-pointer';

export interface SubtleButtonLinkProps {
  children: React.ReactNode;
  /** Optional for link. Required when href is omitted (button mode). Stops propagation. */
  onClick?: (e: React.MouseEvent) => void;
  /** Optional right icon. Defaults to FileSendIcon. Set to null to hide. */
  icon?: React.ReactNode | null;
  className?: string;
}

const DefaultIcon = () => <FileSendIcon className="w-5 h-5 shrink-0" aria-hidden />;

export const SubtleButtonLink: React.FC<SubtleButtonLinkProps> = ({
  children,
  onClick,
  icon,
  className,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    onClick?.(e);
    e.stopPropagation();
  };

  const content = (
    <>
      {children}
      {icon !== null && (icon !== undefined ? icon : <DefaultIcon />)}
    </>
  );

  return (
    <button type="button" onClick={handleClick} className={classNames(BASE_CLASSES, className)}>
      {content}
    </button>
  );
};
